/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Nav from "./Nav";
import axios from "axios";
import { useCountry } from "../../context/country";
import { useAuth } from "../../context/auth";
import { Link, useLocation } from "react-router-dom";
import { Modal } from "react-bootstrap";
import CountdownTimer from "../../pages/CountdownTimer";
import NewLoginRegister from "./NewLoginRegister";

export default function Header() {
  const [auth, setAuth] = useAuth();
  const location = useLocation();
  const [country, setCountry] = useCountry("");
  const [countryCode, setCountryCode] = useState("");
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showPopup, setShowPopup] = useState(() => {
    const popupShown = localStorage.getItem("popupShown");
    return popupShown ? JSON.parse(popupShown) : false;
  });
  const isProductPage = location.pathname.startsWith("/product/");

  // ✅ Default India Data
  const defaultIndia = {
  country_code: "IN",
  calling_code: "+91",
  code: "INR",
  currency_name: "INR",
  country_name: "India",
  languages: "en",
  latitude: "20.5937",
  longitude: "78.9629",
  city: "New Delhi",
  region: "Delhi",
  status: true,
};

  const countryPresets = {
    AED: {
      country_code: "AE",
      calling_code: "+971",
      code: "AED",
      currency_name: "Dirham",
      country_name: "United Arab Emirates",
      status: false,
    },
    CAD: {
      country_code: "CA",
      calling_code: "+1",
      code: "CAD",
      currency_name: "Dollar",
      country_name: "Canada",
      status: false,
    },
  };


  const siteRedirect = async () => {
   // return true;
    if (country?.currency_name) return;
    let apiUrl = "https://ipapi.co/json/";
    const { data } = await axios.get(apiUrl);
    if (data?.country_code === 'SA' || data?.country_code === 'AE' || data?.code === 'AED') {
      window.location.href = 'https://chaashnicouture.ae/';
    }
  }
const getGeoInfo = async () => {
  if (country?.currency_name) return;

  try {
    const queryParams = new URLSearchParams(window.location.search);
    const customCountry = queryParams.get("country");
    const site = process.env.REACT_APP_COUNTRY_SITE;
    let presetData = null;
    let ip = null;

    // ✅ Priority 1: Query param (override)
    const ipMap = {
      USD: "8.8.8.8",
      AED: "83.110.250.231",
      CAD: "24.48.0.1",
    };

    if (customCountry && ipMap[customCountry]) {
      ip = ipMap[customCountry];
    }

    // ✅ Priority 2: Site preset
    if (!ip && site && countryPresets[site]) {
      presetData = countryPresets[site];

      if (ipMap[site]) {
        ip = ipMap[site];
      }
    }

    // 🔥 Single API Call
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_URL}/ip-details`,
      {
        params: {
          ip: ip || null,
        },
      }
    );

    const countryData = {
      country_code: presetData?.country_code || data?.country_code,
      calling_code: presetData?.calling_code || data?.country_calling_code,
      code: presetData?.code || data?.currency,
      currency_name: presetData?.currency_name || data?.currency_name,
      country_name: presetData?.country_name || data?.country_name,
      languages: data?.languages ? data.languages.split(",")[0] : null,
      latitude: data?.latitude || null,
      longitude: data?.longitude || null,
      city: data?.city || null,
      region: data?.region || null,
      status: false,
    }; 

   /*  const countryData = {
  country_code: presetData?.country_code || data?.country_code || defaultIndia.country_code,
  calling_code: presetData?.calling_code || data?.country_calling_code || defaultIndia.calling_code,
  code: presetData?.code || data?.currency || defaultIndia.code,
  currency_name: presetData?.currency_name || data?.currency_name || defaultIndia.currency_name,
  country_name: presetData?.country_name || data?.country_name || defaultIndia.country_name,

  languages: data?.languages
    ? data.languages.split(",")[0]
    : defaultIndia.languages,

  latitude: data?.latitude || defaultIndia.latitude,
  longitude: data?.longitude || defaultIndia.longitude,
  city: data?.city || defaultIndia.city,
  region: data?.region || defaultIndia.region,

  status: presetData?.status ?? data?.status ?? defaultIndia.status,
}; */

    // ✅ Save once
    sessionStorage.setItem("country_data", JSON.stringify(countryData));

    setCountry(countryData);
    setCountryCode(countryData.code);

    // ✅ Call currency once
    getCurrencyInfo(countryData.code);

  } catch (error) {
    console.error("Geo Info Fetch Error:", error);
  }
};
  const getGeoInfo_old = async () => {
    //console.log(country)
    if (country?.currency_name) return;

    const queryParams = new URLSearchParams(window.location.search);
    const customCountry = queryParams.get("country"); // Set custome country

    const site = process.env.REACT_APP_COUNTRY_SITE;
    //console.log("Site Country:", site);
    if (site && countryPresets[site]) {
      setCountry(countryPresets[site]);
      // Fetch geo data
      const { data } = await axios.get("https://ipapi.co/json/");

      const countryData = {
        ...countryPresets[site],
        latitude: data?.latitude || null,
        longitude: data?.longitude || null,
        city: data?.city || null,
        region: data?.region || null,
        languages: data.languages.split(",")[0],
      };

      sessionStorage.setItem(
        "country_data",
        JSON.stringify(countryData)
      );
      setCountryCode(countryPresets[site].code);
      getCurrencyInfo(countryPresets[site].code);
      return;
    }

    try {
      //let apiUrl = 'https://ipapi.co/8.8.8.8/json/'; //US
      //let apiUrl = 'https://ipapi.co/83.110.250.231/json/'; //AED
      let apiUrl = "https://ipapi.co/json/";
      if (
        customCountry &&
        customCountry !== "undefined" &&
        customCountry !== null &&
        customCountry !== ""
      ) {
        if (customCountry === "USD") {
          apiUrl = "https://ipapi.co/8.8.8.8/json/";
        } else if (customCountry === "AED") {
          apiUrl = "https://ipapi.co/83.110.250.231/json/";
        }
      }
      const { data } = await axios.get(apiUrl);
      //console.log('TTT===', data);
      const countryData = {
        country_code: data.country_code,
        calling_code: data.country_calling_code,
        code: data.currency,
        currency_name: data.currency_name,
        country_name: data.country_name,
        languages: data.languages.split(",")[0],
        latitude: data.latitude,
        longitude: data.longitude,
        city: data.city,
        region: data.region,
        status: false,
      };



      setCountry(countryData);
      sessionStorage.setItem("country_data", JSON.stringify(countryData));
      setCountryCode(data.currency);
      getCurrencyInfo(data.currency);
    } catch (error) {
      console.error("Geo Info Fetch Error:", error);
    }
  };

  const getGeoInfo_new = async () => {
    if (country?.currency_name) return;

    try {
      const queryParams = new URLSearchParams(window.location.search);
      const customCountry = queryParams.get("country");
      const site = process.env.REACT_APP_COUNTRY_SITE;
     // console.log("Custom Country:", site, customCountry);
      let apiUrl = "https://ipapi.co/json/";
      let presetData = null;
      let ip = null;
      // ✅ If site preset exists
      if (site && countryPresets[site]) {
        presetData = countryPresets[site];
      }

      // ✅ If custom country via query param
      if (site && ["CAD", "AED"].includes(site)) {
        const ipMap = {
          CAD: "24.48.0.1",
          AED: "83.110.250.231",
        };
        //apiUrl = `https://ipapi.co/${ipMap[customCountry]}/json/`;
        ip = ipMap[site];
        //console.log("===Custom Country IP:", ip);
      }

      // 🔥 Single API Call
      //const { data } = await axios.get(apiUrl);
      //console.log("Custom Country IP:", ip);

      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/ip-details`,
        {
          params: {
            ip: ip || null,
          },
        }
      );


      const countryData = {
        ...(presetData || {}),
        country_code: presetData?.country_code || data?.country_code,
        calling_code: presetData?.calling_code || data?.country_calling_code,
        code: presetData?.code || data?.currency,
        currency_name: presetData?.currency_name || data?.currency_name,
        country_name: presetData?.country_name || data?.country_name,
        languages: data?.languages?.split(",")?.[0] || null,
        latitude: data?.latitude || null,
        longitude: data?.longitude || null,
        city: data?.city || null,
        region: data?.region || null,
        status: false,
      };

      // ✅ Save once
      sessionStorage.setItem("country_data", JSON.stringify(countryData));

      setCountry(countryData);
      setCountryCode(countryData.code);

      // Call currency only once
      getCurrencyInfo(countryData.code);

    } catch (error) {
      console.error("Geo Info Fetch Error:", error);
    }
  };

  const getCurrencyInfo = async (code) => {
    try {
      let currentCode =
        code || JSON.parse(sessionStorage.getItem("country_data"))?.code;
      if (!currentCode) return;

      const cachedCurrency = JSON.parse(
        sessionStorage.getItem("country_currency")
      );
      if (cachedCurrency?.code === currentCode && cachedCurrency?.status === 1)
        return;

      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/cart/exchange-currency?code=${currentCode}`
      );
      sessionStorage.setItem("country_currency", JSON.stringify(data));

      const updatedCountryData = {
        ...JSON.parse(sessionStorage.getItem("country_data")),
        status: true,
      };
      sessionStorage.setItem("country_data", JSON.stringify(updatedCountryData));
    } catch (error) {
      console.error("Currency Fetch Error:", error);
    }
  };

  useEffect(() => {
    siteRedirect();
    getGeoInfo();
  }, []);

  useEffect(() => {
    // Try to get country data from localStorage on refresh
    const countryData = JSON.parse(sessionStorage.getItem("country_data"));

    if (countryData?.code) {
      setCountryCode(countryData.code); // Ensure state updates
    }
  }, []);

  useEffect(() => {
    const cachedCurrency = JSON.parse(sessionStorage.getItem("country_currency"));

    // Fetch only if currency data is missing or outdated
    if (
      countryCode &&
      (!cachedCurrency ||
        cachedCurrency.code !== countryCode ||
        cachedCurrency.status === 0)
    ) {
      getCurrencyInfo(countryCode);
    }
  }, [countryCode]);

  const handlepopupclose = () => {
    setShowPopup(false);
    localStorage.setItem("popupShown", "false");
  };

  useEffect(() => {
    // Check if popup was already shown
    if (!auth?.user?.id) {
      if (location.pathname === "/loginsignup") return;
      const popupShown = localStorage.getItem("loginpopupShown");

      if (!popupShown) {
        const timer = setTimeout(() => {
          setShowLoginPopup(true);
          localStorage.setItem("loginpopupShown", "true"); // Store flag in localStorage
        }, 15000); // 10 seconds delay

        return () => clearTimeout(timer); // Cleanup timer on unmount
      }
    }
  }, [location.pathname, auth]);

  useEffect(() => {
    if (auth?.user?.id) {
      const popupShown = localStorage.getItem("popupShown");

      if (!popupShown) {
        const timer = setTimeout(() => {
          setShowPopup(true);
          localStorage.setItem("popupShown", "true"); // Store flag in localStorage
        }, 5000); // 10 seconds delay

        return () => clearTimeout(timer); // Cleanup timer on unmount
      }
    }
  }, [auth]);
  const [show, setShow] = useState(true);
  return (
    <>

      {auth?.user?.id ? (
        <div className="top-bar-slider" style={{ display: "none" }}>
          Get 15% off on your first purchase.{" "}
          <span>Use Coupon Code : CH15</span>{" "}
          <span className="gray-text">(Not applicable on Sale items)</span>
        </div>
      ) : (
        <div className="top-bar-slider">
          Unlock VIP Discounts! 🎁{" "}
          <Link to="/loginsignup">
            <strong>Sign up</strong>
          </Link>{" "}
          or{" "}
          <Link to="/loginsignup">
            <strong>Login</strong>
          </Link>{" "}
          now and claim your exclusive savings before they disappear!
        </div>
      )}

      <Nav />

      <div className="popupright-bottom">
        {isProductPage && auth?.user?.id && (
          <div className="small-popup-box bottom-right-popup welcome-dis">
            <div className="small-popup">
              <span className="close-popup" onClick={handlepopupclose}>
                &times;
              </span>
              <div className="small-first-popup">
                <p>
                  Tick-Tock ⏳<br /> Your <strong>5% Bonus Off </strong> is Live! <br /> Use it before it's gone in 1 hour!
                </p>
              </div>
            </div>
            <div
              className="small-popup-overloay"
              onClick={() => setShowPopup(false)}
            ></div>
          </div>
        )}

        {showPopup && auth?.user?.id && auth?.user?.couponLimit === 0 && (
          <div className="small-popup-box bottom-right-popup welcome-dis">
            <div className="small-popup">
              <span className="close-popup" onClick={handlepopupclose}>&times;</span>
              <div className="small-first-popup">
                <p>Get <strong>15% Welcome Discount</strong> <br /> on your first purchase. <br /> Use <strong>Coupon Code : CH15</strong></p>
              </div>
            </div>
            <div className="small-popup-overloay" onClick={() => setShowPopup(false)}></div>
          </div>
        )}
      </div>

      {showLoginPopup && !auth?.user?.id && (
        <div className="small-popup-box signup-popup-box ">
          <div className="small-popup">
            <span
              className="close-popup"
              onClick={() => setShowLoginPopup(false)}
            >
              &times;
            </span>
            <div className="small-first-popup">
              <h2>Unlock Exclusive Access</h2>
              <ul className="small-first-popup-ul">
                <li>Enjoy members only discount</li>
                <li>Early access to new collections</li>
                <li>Personalised styling sessions</li>
              </ul>
              <div className="join-box">
                <div className="heading">
                  Join{" "}
                  <img
                    src="/images/signup-chaashnicouture.png"
                    width="369px"
                    height="61px"
                    alt="Chaashni"
                    loading="lazy"
                  />{" "}
                  Today
                </div>
                <form method="GET" action="">
                  <div className="form-wrap">
                    {/* <input type='text' name="signup" placeholder='ENTER EMAIL OR MOBILE NO.' />
                                    <button type='submit'>Sign Up</button> */}
                    <NewLoginRegister
                      show={show}
                      setShowLoginPopup={setShowLoginPopup}
                      redirect={false}
                    />
                  </div>
                </form>
                {/* <div className='already-member'>Already a member? <Link to="#">Click Here</Link></div> */}
                <div className="flower">
                  <img
                    src="/images/flower.png"
                    width="400"
                    height="280"
                    alt="flower"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className="small-popup-overloay" /* onClick={() => setShowLoginPopup(false)} */
          ></div>
        </div>
      )}
      <div style={{ display: "none" }}>
        <CountdownTimer
          initialSeconds={3600}
          onComplete={() => { }}
          storageKey="countdown"
        />
      </div>
    </>
  );
}
